import React, { useMemo } from 'react';

import { spammerLabel } from '../lib/spammer';
import { cn } from '../lib/utils';

import SpammerPopoverContent from './SpammerPopoverContent';
import EntityPopover from './shared/EntityPopover';
import EntityWrapper from './shared/EntityWrapper';
import Flexicon from './shared/Flexicon';

export const SPAMMER_FLEXICON_RESOURCE = {
  flexicon: {
    kind: 'glyph',
    glyph: {
      id: 'letter-e',
      kind: 'letters',
      filename: 'e',
      public_url: 'https://emoji.stdout.host/glyphs/letters/256/e.png',
    },
  },
};

export const SpammerEntity = ({
  spammer,
  dataTarget = null,
  jumbo = false,
  suggestion = false,
  truncated = false,
  // Callers with channel context (e.g. the mention suggestion list) pass the
  // channel record so @everyone wears the chat's own avatar.
  flexiconResource = SPAMMER_FLEXICON_RESOURCE,
}) => {
  const unavailable = useMemo(() => !spammer?.id, [spammer?.id]);
  const label = useMemo(() => spammer?.label ?? spammerLabel(spammer?.id), [spammer?.id, spammer?.label]);

  const popoverContent = unavailable ? null : <SpammerPopoverContent label={label} iconResource={flexiconResource} />;

  return (
    <EntityPopover content={popoverContent} interactive={!unavailable && !suggestion}>
      <EntityWrapper
        data-type="spammer"
        data-target={dataTarget}
        jumbo={jumbo}
        suggestion={suggestion}
        truncated={truncated}
        className={cn('cursor-default', unavailable && 'text-gray-400')}
      >
        <span className={cn('relative top-1', unavailable && 'saturate-0')}>
          <Flexicon resource={flexiconResource} size={jumbo ? 'size-10' : 'size-4'} />
        </span>
        <span className={cn('font-semibold', jumbo && 'text-base', (suggestion || truncated) && 'truncate')}>
          {label}
          {suggestion && <span className="font-normal text-gray-500 dark:text-neutral-500"> (notify all members)</span>}
        </span>
      </EntityWrapper>
    </EntityPopover>
  );
};
